import styled from "styled-components";

export const Row = styled.div`
  display: flex;
`

export const Col = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;

  &:not(:last-child){
    padding-right: 32px;
  }
`